<template>
  <div class="chartWithOverlay">
    <div class="column-chart" v-if="chartShow" style="height: 400px;">
      <GChart type="ColumnChart" :data="chartData" :options="chartOptions" @ready="onChartReady" />
    </div>
  </div>
</template>
<script>
import { GChart } from 'vue-google-charts'

export default {
  name: "ColumnChart",
  props: {
    chartData: Array,
    title: String,
    unflattenned: Boolean,
    resetZoomEvent: Boolean,
    absMaxSerieZero: Number,
    absMinSerieZero: Number,
    absMaxSerieOne: Number,
    absMinSerieOne: Number
  },
  components: {
    GChart
  },
  mounted() {

    this.chartOptions = {
      title: this.title,
      curveType: 'function',
      legend: { position: 'bottom', alignment: 'end' },
      height: 350,
      width: "100%",
      // Gives each series an axis that matches the vAxes number below.
      chartArea: {
        left: 50,
        right: 40,
        top: 10,
        bottom: 40,
        height: '100%',
        width: '100%'
      },
      vAxis: {
        minValue: 1.0
      },
      explorer: {
        actions: ['dragToZoom', 'rightClickToReset'],
        axis: 'horizontal',
        keepInBounds: false,
        maxZoomIn: 4.0
      }
    }
    if (this.unflattenned) {
      this.chartOptions['series'] = {
        0: { targetAxisIndex: 0 },
        1: { targetAxisIndex: 1 }
      }


    }
    this.chartShow = true;
  },
  data() {
    return {
      // Array will be automatically processed with visualization.arrayToDataTable function
      chartsLib: null,
      chart: null,
      chartOptions: null,
      chartShow: false
    }
  },
  methods: {
    onChartReady(chart, google) {
      this.chart = chart;
      this.google = google;
    },
    resetChartZoom() {
      this.chartShow = false;
      this.$nextTick(() => {
        this.chartShow = true;
      })
    },
    getChartAsImage() {
      const uri = this.chart.getImageURI();
      return uri
    },
  },
  watch: {
    resetZoomEvent() {
      this.resetChartZoom()
    }
  }
};
</script>
<style>
.column-chart {
  overflow-x: scroll;
  overflow-y: hidden;
}

.chartWithOverlay {
  position: relative;
}
</style>
